var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellCompanyBrandingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M37.804 23.61h3.79V.12h-3.79v23.49Zm-16.662-9.147a3.368 3.368 0 0 1 3.33-2.96 3.189 3.189 0 0 1 3.274 2.96h-6.604Zm-11.016 5.692a8.892 8.892 0 0 1-1.554.112H5.763v-7.701h2.514a9.55 9.55 0 0 1 2.205.235 3.769 3.769 0 0 1 2.66 4.607 3.755 3.755 0 0 1-3.017 2.75l.001-.003ZM5.764 3.192h1.072a6.67 6.67 0 0 1 2.442.358 2.683 2.683 0 0 1 1.715 2.662 2.918 2.918 0 0 1-2.424 3.081 7.75 7.75 0 0 1-1.538.115H5.766V3.192h-.002ZM31.37 13.85a6.81 6.81 0 0 0-1.184-2.743 6.68 6.68 0 0 0-5.685-2.677c-3.503-.007-6.528 2.463-7.236 5.91a6.547 6.547 0 0 0-4.282-4.192 5.346 5.346 0 0 0 2.135-4.366 5.442 5.442 0 0 0-1.723-4.079C11.812.288 9.655 0 6.997 0H1.8v23.61c1.472 0 2.986-.006 4.46 0 1.313.007 2.595 0 3.79-.052 3.784-.16 6.373-2.16 7.202-5.172.233 1.2.765 2.32 1.547 3.255a7.308 7.308 0 0 0 5.697 2.348 8.128 8.128 0 0 0 5.81-2.024l-1.852-2.29a5.533 5.533 0 0 1-3.474 1.176 3.607 3.607 0 0 1-3.905-3.454H31.37v6.214h3.858V.12H31.37v13.73Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellCompanyBrandingLogo);
export default __webpack_public_path__ + "static/media/BellCompanyBrandingLogo.106ae00352b72f397f2d9a32c688209a.svg";
export { ForwardRef as ReactComponent };